import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, TemplateRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { CompaniesService } from '../../services/companies.service';
import { ConfigService } from '../../../_services/config.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalKcsComponent } from 'src/app/_directives/modal/kcs-modal';
import { Button } from 'src/app/_models/modal/Button';

@Component({
  standalone: false,
	selector: 'app-evento-appuntamento',
	templateUrl: './evento-appuntamento.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./evento-appuntamento.component.scss'],
})
export class EventoAppuntamentoComponent implements OnInit, OnChanges {
	@Input() date!: any;
	@Input() tipo_utenza!: boolean;
	@Input() cmp_id!: number;
	@Input() visible = false;
	@Output() visibleChange = new EventEmitter<boolean>();


 	@ViewChild('inputName') inputName!: ElementRef;
	@ViewChild('addEditComponent') addEditComponent!: TemplateRef<any>;
	title!: string;
	startDate!: string;
	endDate!: string;

	my_user: any = {};
	filter: any = {};
	lstCommesse: any[] = [];
	lstStati: any[] = [];

	slotText: string = '';
	durationText: string = '';

	 

	modalButtons: Button[] = [];

	constructor(
		private modalService: NgbModal,
		private config: ConfigService,
		private companiesManager: CompaniesService,
	) {}

	ngOnInit() {}

	ngOnChanges() {
		this.get_lstStatiAppuntamenti();
		
	}

	get_lstStatiAppuntamenti() {
		this.filter.pagina = 1;
		this.filter.righePagina = 100;
		this.filter.stato = -1;
		this.filter.cli_id = -1;
		this.companiesManager.get_lstAppointmentState().subscribe((res) => {
			if (res) {
				this.lstStati = res;
				if (!this.date) {
			this.date = {};
			this.date.stato = {};
		} else {
			this.date.app_id = this.date.extendedProps.app_id;
			this.date.stato = this.date.extendedProps.stato;
			this.date.usr_id = this.date.extendedProps.usr_id;
			this.date.usr_displayname = this.date.extendedProps.usr_displayname;
			if (this.date.extendedProps.cmp_id) {
				this.cmp_id = this.date.extendedProps.cmp_id;
			}			
		}
		this.my_user = this.config.getUser();
		this.updateSlotTextAndDuration();
		if(this.visible){
   this.openAddEditModal();
 }
			}
		});
	}

	updateSlotTextAndDuration() {
		const start = new Date(this.date.start);
		const end = new Date(this.date.end);

		if (start && end) {
			const startTime = start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
			const endTime = end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

			this.slotText = `Slot: ${startTime} - ${endTime}`;
			const durationMinutes = Math.round((end.getTime() - start.getTime()) / (1000 * 60));
			this.durationText = `Durata: ${durationMinutes} minuti`;
		}
	}

	save() {
		if (this.date.app_id > 0) {
			this.companiesManager.updCompanyAppointment(this.cmp_id, this.date).subscribe((res: any) => {
				if (res > 0) {
					this.config.openSuccessNotify('Appuntamento aggiornato con successo!');
					this.visibleChange.emit(false);
				}
			});
		} else {
			this.companiesManager.addCompanyAppointment(this.cmp_id, this.date).subscribe((res: any) => {
				if (res > 0) {
					this.config.openSuccessNotify('Appuntamento prenotato con successo!');
					this.visibleChange.emit(false);
				}
			});
		}
	}

	handleChangeActivity(event: any) {
		this.visible = event;
		this.visibleChange.emit(event);
	}

	openAddEditModal() {

		/* <button *ngIf="!(
            date.app_id > 0 
            && my_user.usr_id != date.usr_id 
            && tipo_utenza != 'ADMIN'
            )"
            (click)="save()" type="button" cButton style="cursor: pointer;">Salva
        </button>  */
		let button={ label: 'Salva', class: 'kcs-button', action: () => this.save() }
		this.modalButtons = [
				{ label: 'Annulla', class: 'kcs-button-outlined', action: () => this.closeModal() },
			];
		if( !(this.date.app_id > 0 
            && this.my_user.usr_id != this.date.usr_id 
            && !this.tipo_utenza)){
				this.modalButtons.push(button)
			}
		  
			const modalRef = this.modalService.open(ModalKcsComponent, {
			  ariaLabelledBy: 'modal-title',
			});
			let title ='';
			if(this.date.app_id){title='Aggiorna Evento'}else{title='Nuovo Evento'}
			 
			
			modalRef.componentInstance.openModal(title, '', this.modalButtons, 'primary', this.addEditComponent);
			 setTimeout(() => {
				 if (this.visible && this.inputName) {
				this.inputName.nativeElement.focus();
				}
			  });
			modalRef.result.then(
			  () => {
				
			  }
			
			);
		  }
		
		  closeModal() {
			this.modalService.dismissAll();
		  }

}
